/**
 * Shared styled components for feed budget plan tables.
 * Consistent, readable design using brand tokens.
 */

import { Table, TableCell, TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";
import { COLORS } from "app/theme";

export const BudgetTable = styled(Table)({
  tableLayout: "fixed",
  borderCollapse: "separate",
  borderSpacing: 0,
});

export const MonthHeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 700,
  fontSize: "0.75rem",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  padding: theme.spacing(1, 1.5),
  textAlign: "center",
  backgroundColor: "transparent",
  color: "#374151",
  borderBottom: `2px solid #d1d5db`,
  whiteSpace: "nowrap",
  width: 72,
}));

export const LabelHeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 700,
  fontSize: "0.75rem",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  padding: theme.spacing(1, 2),
  backgroundColor: "#fff",
  color: "#374151",
  borderBottom: `2px solid #d1d5db`,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  minWidth: 220,
  width: 220,
  position: "sticky",
  left: 0,
  zIndex: 11,
  [theme.breakpoints.down("sm")]: {
    minWidth: 120,
    width: 120,
    fontSize: "0.65rem",
    padding: theme.spacing(0.5, 1),
  },
}));

export const LabelCell = styled(TableCell)(({ theme }) => ({
  fontSize: "0.8125rem",
  fontWeight: 500,
  padding: theme.spacing(0.75, 2),
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  minWidth: 220,
  width: 220,
  position: "sticky",
  left: 0,
  backgroundColor: "#fff",
  zIndex: 10,
  color: "#374151",
  [theme.breakpoints.down("sm")]: {
    minWidth: 120,
    width: 120,
    fontSize: "0.7rem",
    padding: theme.spacing(0.5, 1),
  },
}));

export const ValueCell = styled(TableCell)(({ theme }) => ({
  fontSize: "0.8125rem",
  padding: theme.spacing(0.75, 1.5),
  textAlign: "right",
  whiteSpace: "nowrap",
  color: "#1f2937",
  width: 72,
}));

export const ComputedRow = styled(TableRow)({
  backgroundColor: "#f8f9fa",
  "& td": {
    borderTop: "1px solid #e0e0e0",
  },
});

export const ComputedLabelCell = styled(LabelCell)({
  fontWeight: 700,
  backgroundColor: "#f8f9fa",
  color: COLORS.dahlia[900],
});

export const ComputedValueCell = styled(ValueCell)({
  fontWeight: 700,
  color: COLORS.dahlia[900],
});

export const DifferenceValueCell = styled(ValueCell, {
  shouldForwardProp: (prop) => prop !== "isNegative",
})<{ isNegative: boolean }>(({ isNegative }) => ({
  fontWeight: 700,
  color: isNegative ? "#dc2626" : COLORS.dahlia[700],
}));

export const HighlightRow = styled(TableRow)({
  backgroundColor: COLORS.dahlia[50],
  "& td": {
    borderTop: "none",
    borderBottom: "none",
  },
});
